<template>
  <div class="component-hotzapp">
    <div class="breadcrumbs d-flex align-items-center font-weight-bold mb-9">
      <router-link :to="{ name: 'home' }" class="text-secondary"
        >Início</router-link
      >
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link :to="{ name: 'tools' }" class="text-secondary">
        Ferramentas
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      <router-link :to="{ name: 'tools-automations' }" class="text-secondary">
        Automações
      </router-link>
      <i class="icon-angle-right text-secondary mx-3"></i>
      Hotzapp
    </div>

    <h6 class="d-none d-lg-block">Hotzapp</h6>
    <div class="row align-items-center mb-5 pt-6">
      <div class="col-lg-3 mb-3">
        <div class="d-flex align-items-center">
          <div class="mr-5">Integrações</div>
          <button
            class="btn btn-sm btn-outline-primary btn-square-sm p-5"
            @click="dispatch"
          >
            <i class="icon-refresh-ccw" />
          </button>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="d-flex algn-items-center justify-content-end">
          <search-filter
            class="mr-3 flex-fill"
            placeholder="Pesquisar conta"
            @search="searching"
            :showFilters="false"
            :showResultsDropdown="false"
          />
          <button
            type="button"
            class="btn btn-primary px-5 px-lg-6"
            @click="modal = true"
          >
            <span class="d-none d-lg-inline">
              Adicionar
            </span>
            <i class="icon-plus d-lg-none lead"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!integrationList.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-9 mx-auto"
              src="@/assets/images/home/welcome.svg"
            />
            <h5>Você ainda não adicionou nenhuma integração</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <!-- Desktop area -->
        <data-table
          class="d-none d-lg-block"
          :data="integrationList"
          :columns="columns"
          :alignTitleLeft="true"
          columnsFr="0.8fr 0.8fr 1fr 0.8fr 0.3fr 0.3fr"
        >
          <template #default="{item}">
            <small class="d-flex align-items-center">
              {{ item.product_name }}
            </small>
            <small class="d-flex align-items-center">
              {{ formatLongText(item.description) }}
            </small>
            <small class="d-flex align-items-center pr-3">
              <button class="btn btn-primary btn-sm mr-2 event-button">
                {{ formatEvent(item.events[0]) }}
              </button>
              <b-dropdown
                v-if="item.events.length > 1"
                size="sm"
                variant="outline-primary event-button"
                :text="`+${item.events.length - 1}`"
              >
                <b-dropdown-text>
                  <div
                    v-for="(event, index) in item.events"
                    :key="index"
                    class="pt-3 px-5 text-secondary small"
                  >
                    {{ formatEvent(event) }}
                  </div>
                </b-dropdown-text>
              </b-dropdown>
            </small>
            <button
              class="btn d-flex align-items-center justify-content-start
              small text-primary text-decoration-none px-0"
              @click="copyUrl(item)"
            >
              {{ item.url | formatLongText }}
            </button>
            <small class="d-flex align-items-center">
              <strong :class="item.status ? 'text-success' : 'text-danger'">{{
                item.status ? "Ativo" : "Inativo"
              }}</strong>
            </small>
            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @change-status="changeStatus(item)"
                @edit="edit(item)"
                @delete="submitDelete(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- Desktop area -->
        <!-- Mobile area -->
        <data-table
          class="d-lg-none"
          :columns="mobileColumns"
          :data="integrationList"
          :firstColumnFr="2"
          :lastColumnFr="0.5"
        >
          <template #default="{ item }">
            <div
              class="d-flex flex-column text-left responsive-bg-secondary-item pl-3 py-5"
            >
              <small class="d-flex align-items-center">
                <strong class="mr-3">Produto: </strong>
                {{ item.product_name }}
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Nome: </strong>
                {{ item.description }}
              </small>
              <small class="d-flex align-items-center pr-3">
                <strong class="mr-3">Eventos: </strong>
                <b-dropdown
                  v-if="item.events.length > 1"
                  size="sm"
                  variant="outline-primary py-0"
                  :text="`${item.events.length}`"
                >
                  <b-dropdown-text>
                    <div
                      v-for="(event, index) in item.events"
                      :key="index"
                      class="pt-3 px-5 text-secondary small"
                    >
                      {{ formatEvent(event) }}
                    </div>
                  </b-dropdown-text>
                </b-dropdown>
                <strong v-else class="px-5 text-primary">
                  {{ formatEvent(item.events[0]) }}
                </strong>
              </small>
              <small class="d-flex align-items-center">
                <strong>Url: </strong>
                <button
                  class="d-flex align-items-center font-weight-bold text-decoration-none border-0 bg-transparent text-primary"
                  @click="copyUrl(item)"
                >
                  {{ item.url | formatLongText }}
                </button>
              </small>
              <small class="d-flex align-items-center">
                <strong class="mr-3">Status: </strong>
                <strong :class="item.status ? 'text-success' : 'text-danger'">{{
                  item.status ? "Ativo" : "Inativo"
                }}</strong>
              </small>
            </div>
            <div
              class="d-flex align-items-center justify-content-end responsive-bg-secondary-item px-3"
            >
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="getActions(item)"
                @change-status="changeStatus(item)"
                @edit="edit(item)"
                @delete="submitDelete(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- Mobile area -->
      </div>
      <div
        v-if="integrationList.length"
        class="d-flex justify-content-center pt-3"
      >
        <paginator :pagination="pagination" @on-update="dispatch" />
      </div>
    </div>
    <hotzapp-modal
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @clear-edit="integrationToEdit = null"
      @update-list="dispatch"
      @loading="loading = true"
    />
  </div>
</template>
<script>
import HotzappModal from "@/components/tools/modals/Hotzapp.vue";
import IntegrationsMixin from "@/mixins/integration.js";
import get from "lodash/get";
import { mapState } from "vuex";
export default {
  components: {
    HotzappModal
  },
  mixins: [IntegrationsMixin],
  data() {
    return {
      loading: false,
      integrationToEdit: null,
      integration: "hotzapp",
      modal: false,
      columns: ["Produto", "Descrição", "Eventos", "URL", "Status", ""],
      mobileColumns: ["", ""]
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["integrationList", "pagination", "typeEvents"]),
    eventsOptions() {
      let options = [...this.typeEvents];
      options.unshift({ id: "", name: "Todos os eventos" });
      return options;
    }
  },
  methods: {
    formatEvent(event) {
      return event
        ? get(
            this.typeEvents.find(t => t.id === event.event),
            "name",
            "Erro ao carregar evento"
          )
        : "Erro ao carregar evento";
    },
    formatLongText(txt) {
      if (txt) {
        return txt.length > 20 ? `${txt.slice(0, 20)}...` : `${txt}`;
      }
      return "-";
    },
    getActions(item) {
      return [
        {
          text: item.status ? "Desativar" : "Ativar",
          class: item.status ? "text-danger" : "text-success",
          icon: "icon-power",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "change-status"
        },
        {
          text: "Editar",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "edit"
        },
        {
          text: "Remover",
          class: "text-danger",
          icon: "icon-trash",
          confirmation: {
            enable: true,
            text: "Deseja mesmo remover esta integração?"
          },
          event: "delete"
        }
      ];
    },
    dispatch() {
      this.$store.dispatch("integration/getTypeEvents");
      let params = {};

      if (this.search) {
        params = { search: this.search };
      }
      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as integrações");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      let data = item;
      data.status = !item.status;
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
        })
        .catch(error => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    },
    searching(v) {
      this.search = v;
      this.dispatch();
    }
  }
};
</script>
<style>
.event-button {
  padding-left: 10px;
  padding-right: 10px;
  font-size: 12px;
}
</style>
